import { v4 as uuidv4 } from 'uuid';
import { combineReducers } from 'redux';
import OnboardingType from "../../../../shared/onboarding/onboarding-type";
import orderReducer from "../order/ducks/reducer";
import { FETCH_TASKS_STATUSES, FETCH_TASKS_STATUS, ADD_TASK_STATUS, UPDATE_TASK_STATUS, DELETE_TASK_STATUS, CLEAR_TASK_STATUS, CLEAR_TASK_STATUS_REDIRECT } from "./actions";
import { UPDATE_TASK_STATUSES_ORDER } from '../order/ducks/actions';

interface TasksState {
  taskStatuses: any[];
  taskStatus: any;
  loadingTaskStatuses: boolean;
  loading: boolean;
  saving: boolean;
  readOnly: boolean;
  onboardingSteps: OnboardingType[];
}

export const OnboardingStep1ClassName = 'task-statuses-onboarding-step-1';
export const OnboardingStep2ClassName = 'task-statuses-onboarding-step-2';
export const OnboardingStep3ClassName = 'task-statuses-onboarding-step-3';
export const OnboardingStep4ClassName = 'task-statuses-onboarding-step-4';
export const OnboardingStep5ClassName = 'task-statuses-onboarding-step-5';

const defaultState: TasksState = {
  taskStatuses: [],
  taskStatus: null,
  loading: true,
  loadingTaskStatuses: true,
  saving: false,
  readOnly: false,
  onboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Mark as Complete',
      content: `When a task is set to this status and this is checked, then the task will be marked as completed.`
    }
  ]
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case FETCH_TASKS_STATUSES + "_PENDING": {
      return {
        ...state,
        loadingTaskStatuses: true,
        errors: null
      };
    }

    case FETCH_TASKS_STATUSES + "_FULFILLED": {
      return {
        ...state,
        taskStatuses: action.payload.data.statuses,
        readOnly: action.payload.data.readOnly,
        loadingTaskStatuses: false
      };
    }

    case FETCH_TASKS_STATUSES + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loadingTaskStatuses: false
      };
    }


    case FETCH_TASKS_STATUS + "_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case FETCH_TASKS_STATUS + "_FULFILLED": {
      const taskStatus = action.payload.data;
      return {
        ...state,
        taskStatus,
        readOnly: action.payload.data.readOnly,
        loading: false
      };
    }

    case FETCH_TASKS_STATUS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case DELETE_TASK_STATUS + "_PENDING": {
      return {
        ...state,
        saving: true,
        errors: null
      };
    }

    case DELETE_TASK_STATUS + "_FULFILLED": {
      const { id } = action.meta;
      const taskStatuses = state.taskStatuses.filter(ts => ts.id !== id);

      return {
        ...state,
        taskStatus: null,
        taskStatuses,
        saving: false,
        redirect: { to: "list" },
      };
    }

    case DELETE_TASK_STATUS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        saving: false
      };
    }


    case ADD_TASK_STATUS + "_FULFILLED": {
      const taskStatus = action.payload.data.filmTaskStatus;
      let taskStatuses = [...state.taskStatuses, taskStatus];
      return {
        ...state,
        taskStatuses,
        redirect: { to: "list" }
      };
    }


    case UPDATE_TASK_STATUS + "_PENDING": {
      return {
        ...state,
        saving: true,
        errors: null
      };
    }

    case UPDATE_TASK_STATUS + "_FULFILLED": {
      const { id, taskStatus } = action.meta;
      const newTaskStatuses = Array.from(state.taskStatuses);
      const taskStatusToUpdate = newTaskStatuses.find(ts => ts.id === id);
      if (taskStatusToUpdate) {
        taskStatusToUpdate.name = taskStatus.name;
      }

      return {
        ...state,
        taskStatuses: newTaskStatuses,
        saving: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case UPDATE_TASK_STATUS + "_REJECTED": {

      return {
        ...state,
        errors: action.payload.response.data.errors,
        saving: false
      };
    }

    case UPDATE_TASK_STATUSES_ORDER + "_FULFILLED": {
      const updatedTaskStatuses = action.meta.taskStatuses;
      const newTaskStatuses = Array.from(state.taskStatuses);

      newTaskStatuses.forEach((newTaskStatus) => {
        const taskStatus = updatedTaskStatuses.find((taskStatus) => taskStatus.id === newTaskStatus.id);
        newTaskStatus.order = taskStatus.order;
      });

      newTaskStatuses.sort((a, b) => a.order - b.order);
      return {
        ...state,
        taskStatuses: newTaskStatuses,
        saving: false,
        errors: null,
        pristine: true
      };
    }

    case CLEAR_TASK_STATUS: {
      return {
        ...state,
        loading: false,
        taskStatus: null,
        errors: null
      };
    }

    case CLEAR_TASK_STATUS_REDIRECT: {
      return {
        ...state,
        redirect: null
      };
    }

    default:
      return state;
  }
};

export default combineReducers({
  rootState: reducer,
  orderState: orderReducer
});

